// extracted by mini-css-extract-plugin
module.exports = {"emptyStateIcon":"_2Ovkvx4b"};